import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { modules } from "byzantine";
import { useNotificationContext } from "cerulean";

const AOIOBItem = () => {
  const { l10n } = useLocalization();
  const { sendNegativeNotification } = useNotificationContext();

  const label = l10n.getString(
    "tools-menu-open-an-account",
    {},
    "Open an account",
  );

  const { fetchAoiobLink } = modules.aoiob.useFetchAoiobLink();

  return (
    <Button
      as="a"
      href={undefined}
      onClick={() => {
        fetchAoiobLink({
          onSuccess: ({ link }: { link: string }) => {
            const success = window.open(link, "_blank");
            // important not to check falsey
            // null is returned if the new browsing context fails
            if (success === null) {
              sendNegativeNotification(l10n.getString(
                "services-item-open-an-account-popup-failed-error",
                null,
                "We cannot open the application. Please adjust your browser's pop-up settings."
              ));
            }
          },
        });
      }}
      kind="menu"
      label={label}
      rel="noreferrer"
      target="_blank"
    />
  );
};

export default AOIOBItem;
